import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// After a deploy the service worker installs the new build and removes the old
// one's files while this page still runs the old code, so its next lazily loaded
// page (Charts, Market watch) is a file that no longer exists and the app went
// blank. Load the new build instead, at most once a minute so a real outage
// cannot cause a reload loop.
window.addEventListener("vite:preloadError", (event) => {
  const KEY = "at.chunk-reload";
  try {
    if (Date.now() - Number(sessionStorage.getItem(KEY) || 0) < 60_000) return;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    return; // storage unavailable: without a guard, do not risk a loop
  }
  event.preventDefault();
  window.location.reload();
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
